<template>
    <div class="tab-text">
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Text Color</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <color-picker
                    :color="form.txtcolor"
                    :sucker-hide="true"
                    :sucker-canvas="suckerCanvas"
                    :sucker-area="suckerArea"
                    @changeColor="changeTextColor"
                />
            </div>
        </div>
        <div
            class="vx-row mb-6"
            v-if="role === 'so-admin'"
        >
            <div class="vx-col sm:w-1/3 w-full">
                <span>Highlight Color</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <color-picker
                    :color="form.hicolor"
                    :sucker-hide="true"
                    :sucker-canvas="suckerCanvas"
                    :sucker-area="suckerArea"
                    @changeColor="changeHiColor"
                />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Favicon</span>
                <div style="font-size:0.75rem; color:#aaa;">
                    Square logo image with recommended size of 300x300px
                </div>
                
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <div style="position:relative;" v-if="form.favicon != null">
                    <img
                        :src="form.favicon"
                        class="mr-3"
                        style="width: 100px; height: 100px; object-fit: cover;"
                    />
                </div>
                <div
                    v-if="!form.favicon"
                    style="width: 300px; height: 158px; background-color: #F5F5F5; border-radius: 8px; position: relative;"
                >
                    <vs-button
                        style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
                        color="dark"
                        type="border"
                        @click="chooseImage('favicon')"
                    >
                        <span>Upload</span>
                    </vs-button>
                    <!-- <input
                        id="file-upload-img"
                        @change="onUploadImages('favicon')"
                        type="file"
                        ref="fileImage"
                        :accept="acceptFileFavivon"
                    > -->
                </div>
                <div
                    class="grid-button-upload"
                    style="margin-top: 8px;display: grid;grid-template-columns: repeat(2, min-content);grid-gap: 10px;"
                >
                    <!-- secondary / border  >> btn-->
                    <vs-button
                        v-if="form.favicon"
                        color="dark"
                        type="border"
                        icon="autorenew"
                        style="display: flex"
                        @click="chooseImage('favicon')"
                    >
                        <span>Change</span>
                    </vs-button>
                    <input
                        id="file-upload-img"
                        @change="onUploadImages('favicon')"
                        type="file"
                        ref="fileImage"
                        :accept="acceptFileFavivon"
                    >
                    <vs-button
                        v-if="form.favicon"
                        color="dark"
                        type="border"
                        icon="delete_forever"
                        style="display: flex"
                        @click="popupActivo=true"
                    >
                        Remove
                    </vs-button>
                    <vs-popup
                        classContent="popup-confirm"
                        title="Confirm Delete"
                        :active.sync="popupActivo"
                    >
                        <div>Are you sure you want to delete the image?</div>
                        <div class="wrap-button">
                            <vs-button
                                color="dark"
                                type="border"
                                style="font-size: 12px !important;"
                                @click="popupActivo=false"
                            >
                                No
                            </vs-button>
                            <vs-button
                                color="primary"
                                style="font-size: 12px !important;"
                                @click="removeFavicon"
                            >
                                Yes
                            </vs-button>
                        </div>
                    </vs-popup>
                </div>
                <!-- <div> -->
                    <!-- <vs-upload
                        v-if="!uploadSeller"
                        :multiple="false"
                        :automatic="true"
                        :single-upload="true"
                        :show-upload-button="false"
                        :action="iconUploadUrl"
                        :fileName="`file`"
                        :limit="1"
                        :data="faviconData"
                        :headers="posterUploadHeader"
                        @on-success="successFaviconUpload"
                        @on-error="errorFaviconUpload"
                    /> -->
                    <!-- <vs-upload
                        v-if="!form.favicon || changeFav"
                        :multiple="false"
                        :automatic="true"
                        :single-upload="true"
                        :show-upload-button="false"
                        :fileName="`favicon`"
                        :limit="1"
                        @change="successFavUpload"
                        @on-delete="deleteFileFavicon"
                        accept="image/png, image/jpeg, image/jpg, image/webp"
                    /> -->
                <!-- </div> -->
                <!-- <div
                    class="grid-button-upload"
                    v-if="form.favicon || showBtn"
                >
                    <vs-button
                        color="dark"
                        type="flat"
                        icon="autorenew"
                        style="display: flex"
                        @click="changeFavicon()"
                    >
                        Change
                    </vs-button>
                    <vs-button
                        color="dark"
                        type="flat"
                        icon="delete_forever"
                        style="display: flex"
                        @click="removeFavicon()"
                    >
                        Remove
                    </vs-button>
                </div> -->
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Background Color</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <color-picker
                    :color="form.bgcolor"
                    :sucker-hide="true"
                    :sucker-canvas="suckerCanvas"
                    :sucker-area="suckerArea"
                    @changeColor="changeBgColor"
                />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Background Image</span>
                <div style="font-size:0.75rem; color:#aaa;">
                    Recommended size: 1500x1800px. File size must be less than 1 mb.
                </div>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
                <div
                    style="position:relative;"
                    v-if="form.bgimg != null"
                >
                    <img
                        :src="form.bgimg"
                        :width="imageWidth"
                        :height="imageHeight"
                    />
                </div>
                <!-- <div style="position:relative;" v-if="form.bgimg != null">
                    <img
                        :src="form.bgimg"
                        class="mr-3"
                        style="width: 100px; height: 100px; object-fit: cover;"
                    />
                </div> -->
                <div
                    v-if="!form.bgimg || form.bgimg == ''"
                    style="width: 300px; height: 158px; background-color: #F5F5F5; border-radius: 8px; position: relative;"
                >
                    <vs-button
                        style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
                        color="dark"
                        type="border"
                        @click="chooseImage('bgimg')"
                    >
                        <span>Upload</span>
                    </vs-button>
                    <!-- <input
                        id="file-upload-bgImg"
                        @change="onUploadImages('bgimg')"
                        type="file"
                        ref="fileImage"
                        :accept="acceptFile"
                    > -->
                </div>
                <div
                    class="grid-button-upload"
                    style="margin-top: 8px;display: grid;grid-template-columns: repeat(2, min-content);grid-gap: 10px;"
                >
                    <!-- secondary / border  >> btn-->
                    <vs-button
                        v-if="form.bgimg"
                        color="dark"
                        type="border"
                        icon="autorenew"
                        style="display: flex"
                        @click="chooseImage('bgimg')"
                    >
                        <span>Change</span>
                    </vs-button>
                    <input
                        id="file-upload-bgImg"
                        @change="onUploadImages('bgimg')"
                        type="file"
                        ref="filePoster"
                        :accept="acceptFile"
                    >
                    <vs-button
                        v-if="form.bgimg"
                        color="dark"
                        type="border"
                        icon="delete_forever"
                        style="display: flex"
                        @click="popupActivo2=true"
                    >
                        Remove
                    </vs-button>
                    <vs-popup
                        classContent="popup-confirm"
                        title="Confirm Delete"
                        :active.sync="popupActivo2"
                    >
                        <div>Are you sure you want to delete the image?</div>
                        <div class="wrap-button">
                            <vs-button
                                color="dark"
                                type="border"
                                style="font-size: 12px !important;"
                                @click="popupActivo2=false"
                            >
                                No
                            </vs-button>
                            <vs-button
                                color="primary"
                                style="font-size: 12px !important;"
                                @click="removeBgImg"
                            >
                                Yes
                            </vs-button>
                        </div>
                    </vs-popup>
                </div>
                <!-- <div> -->
                    <!-- <vs-upload
                        v-if="!uploadSeller"
                        :multiple="false"
                        :automatic="true"
                        :single-upload="true"
                        :show-upload-button="false"
                        :action="posterUploadUrl"
                        :fileName="`file`"
                        :limit="1"
                        :data="bgImgData"
                        :headers="posterUploadHeader"
                        @on-success="successPosterUpload"
                        @on-error="errorPosterUpload"
                    /> -->
                    <!-- <vs-upload
                        v-if="!form.bgimg || changeImage"
                        :multiple="false"
                        :automatic="true"
                        :single-upload="true"
                        :show-upload-button="false"
                        :fileName="`logo`"
                        :limit="1"
                        @change="successBackgroundUpload"
                        @on-delete="deleteFileBackground"
                        accept="image/png, image/jpeg, image/jpg, image/webp"
                    /> -->
                <!-- </div> -->
                <!-- <div
                    class="grid-button-upload"
                    v-if="form.bgimg || showBtn"
                >
                    <vs-button
                    color="dark"
                    type="flat"
                    icon="autorenew"
                    style="display: flex"
                    @click="changeBgImg()"
                    >
                    Change
                    </vs-button>
                    <vs-button
                    color="dark"
                    type="flat"
                    icon="delete_forever"
                    style="display: flex"
                    @click="removeBgImg()"
                    >
                    Remove
                    </vs-button>
                </div> -->
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Font</span>
            </div>
            <vs-select
                autocomplete
                @input-change="autoCompleteFunc"
                class="vx-col sm:w-1/3 w-full"
                v-model="form.font"
                placeholder="Google Font"
            >
                <vs-select-item :key="index" :value="item.family" :text="item.family" v-for="(item,index) in fontList" />
            </vs-select>
        </div>
        <div style="height:10px;"></div>
        <div class="vx-row pt-5 mt-5">
          <div class="vx-col w-full ml-auto">
            <vs-button class="mr-3 mb-2" @click="submitBasic">Submit</vs-button>
            <vs-button v-if="showSellerCancel" class="mr-3 mb-2" type="border" @click="canceled">Cancel </vs-button>
          </div>
        </div>
    </div>
</template>

<script>
import Service from "@/services";

import { timezones } from "@/utils/Timezones";

import colorPicker from "@caohenghu/vue-colorpicker";

export default {
    components: {
        colorPicker
    },
    props: [ 'form', 'e', 'folder', 'role' ],
    data() {
        return {
            posterUploadUrl: process.env.VUE_APP_API_URL + "/events/" + this.folder + "/upload",
            // iconUploadUrl: process.env.VUE_APP_API_URL + "/events/" + this.$route.query.e + "/upload",
            iconUploadUrl: process.env.VUE_APP_API_URL + "/events/" + this.folder + "/upload",
            posterUploadHeader: {
                Authorization:
                "Bearer " +
                JSON.parse(localStorage.getItem("soldoutt-nimda")).Auth.accessToken
            },
            posterData: {
                type: "poster"
            },
            bgImgData: {
                type: "bgimg"
            },
            faviconData: {
                type: "favicon"
            },
            timezones: timezones,
            suckerArea: [],
            suckerCanvas: null,
            fontList: [],
            showSellerCancel: false,
            uploadSeller: false,
            uploadFavicon: false,
            bgimg: '',
            icon: '',
            changeImage: false,
            changeFav: false,
            showBtn: false,
            imageWidth: 0,
            imageHeight: 0,
            acceptFile: [
                'image/png',
                'image/jpeg',
                'image/jpg',
                'image/webp',
            ],
            acceptFileFavivon: [
                'image/png',
                'image/jpeg',
                'image/jpg',
                'image/webp',
            ],
            popupActivo: false,
            popupActivo2: false
        }
    },
    methods: {
        changeTextColor(color) {
            this.form.txtcolor = color.hex;
        },
        changeBgColor(color) {
            this.form.bgcolor = color.hex;
        },
        changeHiColor(color) {
            this.form.hicolor = color.hex;
        },
        successPosterUpload(res) {
            Service.Event.get(this.e)
                .then(res => {
                this.form = res.data.event;
                })
                .catch(e => {
                /* this.$router.push("/pages/error-404").catch(() => {}); */
                });
            this.$vs.notify({
                color: "success",
                title: "Upload Success",
                text: "Poster upload success!"
            });
        },
        successFaviconUpload(res) {
            // const data = res.target.response.replace(/\\/g, '')
            // const iconData = JSON.parse(data)
            // this.icon = iconData.path
            // console.log(iconData.path, 'icon')
            Service.Event.get(this.e)
                .then(res => {
                this.form = res.data.event;
                })
                .catch(e => {
                /* this.$router.push("/pages/error-404").catch(() => {}); */
                });
            this.$vs.notify({
                color: "success",
                title: "Upload Success",
                text: "Favicon upload success!"
            });
        },
        errorPosterUpload(res) {
            this.$vs.notify({
                color: "danger",
                title: "Upload Fail",
                text: "Poster upload fail!"
            });
        },
        errorFaviconUpload(res) {
            this.$vs.notify({
                color: "danger",
                title: "Upload Fail",
                text: "Favicon upload fail!"
            });
        },
        submitBasic() {
            const path = this.$route.path.includes('/sellers/')
            if (path) {
                this.form.bgimg = this.bgimg
                this.form.favicon = this.icon
                this.form.bgcolor = this.form.bgcolor === 'null'? '': this.form.bgcolor
                this.form.hicolor = this.form.hicolor === 'null'? '': this.form.hicolor
                this.form.font = this.form.font === 'null' ? '': this.form.font
                this.$emit('submitBasic', this.form)
            }
            else {
                this.$vs.loading();
                const formData = new FormData();
                const dataKeyForms = Object.keys(this.form);
                for (let index = 0; index < dataKeyForms.length; index++) {
                    const key = dataKeyForms[index];
                    const value = this.form[key];
                    formData.append(key, value);
                }
                Service.Event.saveMerchant(formData, this.e)
                    .then(res => {
                        this.$vs.loading.close();
                        this.$vs.notify({
                            title: "Success",
                            text: "Update complete.",
                            color: "success"
                        });
                    })
                    .catch(e => {
                        this.$vs.loading.close();
                    });
            }
        },
        getFont() {
            Service.Font.getFontList()
                .then(response => {
                    this.fontList = response.items
                })
                .catch(() => {})
        },
        autoCompleteFunc(val) {},
        canceled() {
            this.$router.push('/sellers')
        },
        successBackgroundUpload(res, file) {
            this.bgimg = file[0]
            this.changeImage = false
            this.showBtn = true
            this.updateBgImg()
        },
        updateBgImg() {
            this.form.bgimg = this.bgimg
            const merchantId = {
                id: this.$route.params.merchant_id
            }
            this.form.s = this.$route.query.s
            const formData = new FormData()
            const dataKeyForms = Object.keys(this.form);
                for (let index = 0; index < dataKeyForms.length; index++) {
                    const key = dataKeyForms[index];
                    const value = this.form[key]  === null ? '': this.form[key];
                    formData.append(key, value);
                }
            
                Service.Merchant.updateMerchant(formData, merchantId.id)
                .then(res => {
                    this.changeImage = false
                    this.form.bgimg = res.data.bgimg
                    // this.$vs.loading.close();
                    this.$vs.notify({
                        title: "Success",
                        text: "Update backgroung image complete.",
                        color: "success"
                    });
                })
                .catch(e => {
                    this.$vs.loading.close();
                });
        },
        updateFavicon() {
            this.form.favicon = this.icon
            const merchantId = {
                id: this.$route.params.merchant_id
            }
            this.form.s = this.$route.query.s
            const formData = new FormData()
            const dataKeyForms = Object.keys(this.form);
                for (let index = 0; index < dataKeyForms.length; index++) {
                    const key = dataKeyForms[index];
                    const value = this.form[key]  === null ? '': this.form[key];
                    formData.append(key, value);
                }
            
                Service.Merchant.updateMerchant(formData, merchantId.id)
                .then(res => {
                    this.changeFav = false
                    this.form.favicon = res.data.favicon
                    // this.$vs.loading.close();
                    this.$vs.notify({
                        title: "Success",
                        text: "Update favicon complete.",
                        color: "success"
                    });
                })
                .catch(e => {
                    this.$vs.loading.close();
                });
        },
        changeBgImg() {
            this.changeImage = true
            this.showBtn = true
        },
        removeBgImg() {
            this.form.bgimg = null
            const merchantId = {
                id: this.$route.params.merchant_id
            }
            this.form.s = this.$route.query.s
            const formData = new FormData()
            const dataKeyForms = Object.keys(this.form);
                for (let index = 0; index < dataKeyForms.length; index++) {
                    const key = dataKeyForms[index];
                    const value = this.form[key]  === null ? '': this.form[key];
                    formData.append(key, value);
                }
            formData.append('remove', 'bgimg')
            
            Service.Merchant.updateMerchant(formData, merchantId.id)
                .then(res => {
                    // this.$vs.loading.close();
                    this.$vs.notify({
                        title: "Success",
                        text: "Remove Backgrond image complete.",
                        color: "success"
                    });
                    this.popupActivo2 = false
                })
                .catch(e => {
                    this.$vs.loading.close();
                });
        },
        changeFavicon() {
            this.changeFav = true
            this.showBtn = true
        },
        removeFavicon() {
            this.form.favicon = null
            const merchantId = {
                id: this.$route.params.merchant_id
            }
            this.form.s = this.$route.query.s
            const formData = new FormData()
            const dataKeyForms = Object.keys(this.form);
                for (let index = 0; index < dataKeyForms.length; index++) {
                    const key = dataKeyForms[index];
                    const value = this.form[key]  === null ? '': this.form[key];
                    formData.append(key, value);
                }
            formData.append('remove', 'favicon')
            
            Service.Merchant.updateMerchant(formData, merchantId.id)
                .then(res => {
                    // this.$vs.loading.close();
                    this.$vs.notify({
                        title: "Success",
                        text: "Remove favicon complete.",
                        color: "success"
                    });
                    this.popupActivo = false
                })
                .catch(e => {
                    this.$vs.loading.close();
                });
        },
        successFavUpload(res, file) {
            this.icon = file[0]
            this.changeFav = false
            this.showBtn = true
            this.updateFavicon()
        },
        deleteFileBackground(res) {
            if (res) {
                this.form.bgimg = null
            }
        },
        deleteFileFavicon(res) {
            if (res) {
                this.form.favicon = null
            }
        },
        removeAsset(type) {
            let data = {};
            if (type == "background") {
                data.remove = "bgimg";
            } else if (type == "poster") {
                data.remove = "poster";
            }
            else if (type == 'favicon') {
                data.remove = "favicon";
            }

            Service.Event.update({
                ...data,
                e: this.folder
            }).then(res => {
                if (res.success) {
                this.$vs.notify({
                    title: "Success",
                    text: "Update complete.",
                    color: "success"
                });
                }
                this.event.bgimg = null;
                this.$vs.loading.close();
            });
        },
        setImageSize () {
            let posterimage = document.querySelector('img')
            let w = posterimage.naturalWidth;
            let h = posterimage.naturalHeight;
            this.imageHeight = h
            this.imageWidth = w
            
            if (w > h) {
                this.imageWidth = 300
                this.imageHeight = 'auto'
            }
            else {
                this.imageHeight = 300
                this.imageWidth = 'auto'
            }
        },
        chooseImage(val) {
            if (val === 'favicon') {
                document.getElementById("file-upload-img").click()
            }
            else {
                document.getElementById("file-upload-bgImg").click()
            }
        },
        onUploadImages(val) {
            if (val === 'favicon') {
                this.form.favicon = this.$refs.fileImage.files[0]
                this.icon = this.$refs.fileImage.files[0]
                const reader = new FileReader()
                reader.onloadend = async() => {
                    this.form.favicon = reader.result
                    this.updateFavicon(this.icon)
                    // this.posterUpdate = reader.result
                    this.setImageSize()
                }
                reader.readAsDataURL(this.$refs.fileImage.files[0])
                this.$refs.fileImage.value = null
            }
            else {
                this.bgimg = this.$refs.filePoster.files[0]
                this.form.bgimg = this.$refs.filePoster.files[0]
                const reader = new FileReader()
                reader.onloadend = async() => {
                    this.form.bgimg = reader.result
                    this.updateBgImg(this.bgimg)
                    // this.posterUpdate = reader.result
                    this.setImageSize()
                }
                reader.readAsDataURL(this.$refs.filePoster.files[0])
                this.$refs.filePoster.value = null
            }
        }
    },
    mounted() {
        this.setImageSize()
        this.getFont();
        this.showSellerCancel = this.$route.path.includes('/sellers/') ? true: false;
        this.uploadSeller = this.$route.path.includes('/sellers/') ? true: false
        this.uploadFavicon = this.$route.path.includes('/sellers/') ? true: false
    }
    
};
</script>
<style lang="scss" scoped>
  .grid-button-upload {
    margin-top: 8px;
    display: grid;
    grid-template-columns: repeat(2, min-content);
    grid-gap: 10px;
  }
  .vs-button {
    font-size: 10px !important;
  }
  input[type="file"] {
	display: none !important;
}
    .popup-confirm {
        & div {
            width: 100%;
            text-align: center;
        }
        & .wrap-button {
            display: grid;
            grid-template-columns: repeat(2, 25%);
            grid-gap: 8px;
            justify-content: flex-end;
            margin-top: 20px;
        
        }
    }
  </style>
  